const accordionEnterX = origin => ({
  from: { transform: 'scaleX(0)', transformOrigin: origin },
  to: { transform: '', transformOrigin: origin },
})

const accordionLeaveX = origin => ({
  from: { transform: '', transformOrigin: origin },
  to: { transform: 'scaleX(0)', transformOrigin: origin },
})

const accordionEnterY = origin => ({
  from: { transform: 'scaleY(0)', transformOrigin: origin },
  to: { transform: '', transformOrigin: origin },
})

const accordionLeaveY = origin => ({
  from: { transform: '', transformOrigin: origin },
  to: { transform: 'scaleY(0)', transformOrigin: origin },
})

export const accordionEnterLeft  = accordionEnterX('left center')
export const accordionLeaveRight = accordionLeaveX('right center')

export const accordionEnterBottom = accordionEnterY('center bottom')
export const accordionLeaveTop    = accordionLeaveY('center top')

export const accordionEnterTop    = accordionEnterY('center top')
export const accordionLeaveBottom = accordionLeaveY('center bottom')

export const nullEnter = {
  from: { transform: 'scaleX(1)', transformOrigin: 'center' },
  to: { transform: 'scaleX(1)', transformOrigin: 'center' },
}
export const nullLeave = {
  from: { transform: 'scaleX(0)', transformOrigin: 'center' },
  to: { transform: 'scaleX(0)', transformOrigin: 'center' },
}

export const slideRightEnter = {
  from: { transform: 'translateX(-100%)', opacity: 1},
  to: { transform: 'translateX(0%)', opacity: 1}
}

export const slideRightLeave = {
  from: { transform: 'translateX(0%)', opacity: 1},
  to: { transform: 'translateX(100%)', opacity: 1}
}

export const slideDownFadeOutLeave = (yTarget) => ({
  from: { transform: 'translateY(0%)', opacity: 1 },
  to: { transform: `translateY(${yTarget || '100%'})`, opacity: 0 }
})

export const slideDownFadeInEnter = (yTarget) => ({
  from: { transform: `translateY(${yTarget || '-100%'})`, opacity: 0 },
  to: { transform: 'translateY(0%)', opacity: 1 },
})

export const slideRightFadeOutLeave = (xTarget) => ({
  from: { transform: 'translateX(0%)', opacity: 1 },
  to: { transform: `translateX(${xTarget || '100%'})`, opacity: 0 }
})

export const slideRightFadeInEnter = (xTarget) => ({
  from: { transform: `translateX(-${xTarget || '100%'})`, opacity: 0 },
  to: { transform: 'translateX(0%)', opacity: 1 },
})

export const customFadeOut = (fromOpacity) => ({
  from: { opacity: fromOpacity },
  to: { opacity: 0 }
})
